import {ApiClient} from '@hconnect/apiclient'
import {Iso8601} from '@hconnect/common/types'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {CqdbMaterialsDto, CqdbMaterialsTableType} from '../../../types'
import {prepareCqdbMaterialsTableFromDto} from '../../../utils'
const QueryKey = 'get-cqdb-measurements'

export const useGetCqdbMeasurements = (
  unitLabel: string,
  plantId: string,
  equipmentName: string,
  queryRange: {startDate?: Iso8601; endDate?: Iso8601},
  productType?: string
) => {
  return useQuery<CqdbMaterialsTableType, AxiosError>({
    queryKey: [QueryKey, plantId, equipmentName, productType, queryRange],
    queryFn: async () => {
      if (productType) {
        const path = `/kpi-result/${plantId}/material-quality/measurements`
        const response = await ApiClient.axiosInstance.get<CqdbMaterialsDto>(path, {
          params: {
            startDate: queryRange.startDate,
            endDate: queryRange.endDate,
            equipment: equipmentName,
            type: productType
          }
        })
        return prepareCqdbMaterialsTableFromDto(response.data.materials, unitLabel)
      } else {
        return Promise.resolve({columns: [], rows: []})
      }
    }
  })
}
